import { Box, SxProps, Theme } from "@mui/material";
import { useState } from "react";
import { useSpring, animated } from "react-spring";

interface IProps {
  sx?: SxProps<Theme>;
  thumbnailUrl: string;
  mainUrl: string;
  alt: string;
}

const AnimatedImage: React.FC<IProps> = ({
  sx,
  thumbnailUrl,
  mainUrl,
  alt,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false); // Image loading state

  // Handle image loading
  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const fadeInProps = useSpring({
    opacity: imageLoaded ? 1 : 0,
    from: { opacity: 0 },
    config: { duration: 300 },
  });

  const fadeInThumbProps = useSpring({
    opacity: imageLoaded ? 0 : 1, // Hide thumbnail when full image is loaded
    from: { opacity: 1 },
    config: { duration: 300 },
    filter: `blur(10px)`,
  });

  return (
    <Box sx={{ ...sx, position: "relative" }}>
      <animated.img
        src={thumbnailUrl}
        alt={`${alt} preview`}
        style={{
          ...fadeInThumbProps,
          position: "relative",
          zIndex: 1,
          transition: "opacity 0.3s ease",
        }}
      />
      <animated.img
        src={mainUrl}
        alt={alt}
        loading="lazy"
        style={{
          ...fadeInProps,
          position: "absolute",
          zIndex: 2,
          top: 0,
          left: 0,
          transition: "opacity 0.3s ease",
        }}
        onLoad={handleImageLoad}
      />
    </Box>
  );
};

export default AnimatedImage;
